import React from "react";
import { useNavigate } from "react-router-dom";

const CTA = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact", { state: { scrollTo: "contact-section" } });
  };

  const handleViewMoreClick = () => {
    // Add your logic for "View More" action here
    console.log("View More clicked");
  };

  return (
    <section className="hero-pattern-dots bg-white dark:bg-slate-900 py-8 sm:py-16 px-4 sm:px-6 text-textDark dark:text-textLight transition-colors duration-300">
      <div className="max-w-screen-xl mx-auto">
        <div className="max-w-screen-md">
          <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-slate-700 dark:text-slate-100">
            Ready to Transform Your Business?
          </h2>
          <p className="mb-8 font-light text-slate-600 dark:text-slate-300 sm:text-xl">
            Let Blackbear Technologies help you streamline operations, unlock data-driven insights,
            and automate your future with AI and full-stack innovation.
          </p>
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
            <button
              onClick={handleContactClick}
              className="inline-flex items-center justify-center px-4 py-2.5 text-base font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-600 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 transition"
            >
              Contact Us
            </button>
            <button
              onClick={handleViewMoreClick}
              className="inline-flex items-center justify-center px-4 py-2.5 text-base font-medium text-slate-700 dark:text-slate-300 border border-gray-400 dark:border-gray-600 rounded-lg bg-white dark:bg-slate-800 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 transition"
            >
              <svg
                className="mr-2 -ml-1 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
              </svg>
              View more
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
